  // Standardwerte setzen, falls JavaScript verzögert lädt
  window.addEventListener('load', function() {
    // Standardtexte in Deutsch setzen
    const sizeTitle = document.getElementById("sizeTitle");
    const unitLabel = document.getElementById("unitLabel");
    const footLengthLabel = document.getElementById("footLengthLabel");
    const measureHint = document.getElementById("measureHint");
    const calculateButton = document.getElementById("calculateButton");
    const chartButton = document.getElementById("chartButton");
    const sizeResult = document.getElementById("sizeResult");

    if (sizeTitle) sizeTitle.innerText = "Finde deine Schuhgröße";
    if (unitLabel) unitLabel.innerText = "Einheit";
    if (footLengthLabel) footLengthLabel.innerText = "Fußlänge (in mm)";
    if (calculateButton) calculateButton.innerText = "Größe berechnen";
    if (chartButton) chartButton.innerText = "Größentabelle";

    // measureHint und sizeResult werden hier bewusst NICHT gesetzt: beide Texte
    // hängen von der Variante ab (Schuhe/Sandalen). Das Snippet liefert sie
    // variantengerecht vorgerendert, updateTranslations() setzt sie je Sprache.
    void measureHint; void sizeResult;

    // Dann die Übersetzungsfunktion aufrufen
    if (typeof updateTranslations === 'function') {
      updateTranslations();
    }
  });
  
  // Übersetzungsobjekt mit den Texten in Deutsch, Englisch, Tschechisch und Spanisch
  var translations = {
    de: {
      sizeTitle: "Finde deine Schuhgröße",
      unitLabel: "Einheit",
      footLengthLabelMm: "Fußlänge (in mm)",
      footLengthLabelInch: "Fußlänge (in inch)",
      placeholderLengthMm: "z.B. 270",
      placeholderLengthInch: "z.B. 10,6",
      measureHint: "Stelle dich mit Socken auf ein Blatt Papier und schiebe die Ferse an die Wand. Markiere das Ende deines längsten Zehs mit einem senkrecht gehaltenen Stift und miss den Abstand zur Wand. Wiederhole das für beide Füße – der größere Wert bestimmt deine BLUSUN-Größe.",
      calculateButton: "Größe berechnen",
      chartButton: "Größentabelle",
      errorText: "Bitte alle Werte eingeben.",
      noSizeText: "Keine passende Größe gefunden.",
      sizeText: "Deine Größe: EU {EU} / US {US}",
      sizeTextEuOnly: "Deine Größe: EU {EU}",
      placeholderText: "Hier erscheint deine Schuhgröße",
      // Overlay translations
      overlayIntro1: "Falls du wegen deiner Schuhgröße unsicher bist, kannst du hier anhand unserer Maße die passende Größe herausfinden.",
      overlayIntro2: "Bitte beachte, dass du bei der Messung deines Fußes immer 10–12 mm Platz hinzurechnen solltest. Unsere Leisten sind so gestaltet, dass sie sich sowohl in der Länge als auch in der Breite optimal an den Fuß anpassen. In der folgenden Tabelle findest du die Innenschuhmaße unserer Barfußschuhe.",
      overlayIntro2Sandals: "Bitte beachte, dass du bei der Messung deines Fußes immer 10–12 mm Platz hinzurechnen solltest. In der folgenden Tabelle findest du die Innenmaße unserer Sandalen-Sohle.",
      overlayIntro1Sandals: "Falls du wegen deiner Sandalengröße unsicher bist, kannst du hier anhand unserer Maße die passende Größe herausfinden.",
      placeholderTextSandals: "Hier erscheint deine Sandalengröße",
      sizeTextSandals: "Deine Sandalengröße: EU {EU}",
      measureHintSandals: "Stelle dich mit Socken auf ein Blatt Papier und schiebe die Ferse an die Wand. Markiere das Ende deines längsten Zehs mit einem senkrecht gehaltenen Stift und miss den Abstand zur Wand. Wiederhole das für beide Füße – der größere Wert bestimmt deine Sandalengröße.",
      womenTab: "Damen",
      menTab: "Herren",
      tableHeaders: {
        eu: "EU",
        uk: "UK",
        us: "US",
        size: "Größe",
        lengthMm: "Innenschuhlänge (mm)",
        lengthIn: "Innenschuhlänge (in)",
        widthMm: "Innenbreite (mm)",
        widthIn: "Innenbreite (in)"
      },
      sandalHeaders: {
        lengthMm: "Innenlänge (mm)",
        widthMm: "Innenbreite (mm)"
      }
    },
    en: {
      sizeTitle: "Find Your Shoe Size",
      unitLabel: "Unit",
      footLengthLabelMm: "Foot length (in mm)",
      footLengthLabelInch: "Foot length (in inch)",
      placeholderLengthMm: "e.g. 270",
      placeholderLengthInch: "e.g. 10.6",
      measureHint: "Stand on a sheet of paper wearing socks and push your heel against the wall. Mark the end of your longest toe with a vertically held pen and measure the distance to the wall. Repeat for both feet – the larger value determines your BLUSUN size.",
      calculateButton: "Calculate Size",
      chartButton: "Size Chart",
      errorText: "Please enter all values.",
      noSizeText: "No matching size found.",
      sizeText: "Your size: EU {EU} / US {US}",
      sizeTextEuOnly: "Your size: EU {EU}",
      placeholderText: "Your shoe size will appear here",
      // Overlay translations
      overlayIntro1: "If you're unsure about your shoe size, you can find the right size here using our measurements.",
      overlayIntro2: "Please note that when measuring your foot, you should always add 10-12 mm of space. Our lasts are designed to adapt optimally to the foot in both length and width. The following table shows the inner shoe measurements of our barefoot shoes.",
      overlayIntro2Sandals: "Please note that when measuring your foot, you should always add 10-12 mm of space. The following table shows the inner measurements of our sandal sole.",
      overlayIntro1Sandals: "If you're unsure about your sandal size, you can find the right size here using our measurements.",
      placeholderTextSandals: "Your sandal size will appear here",
      sizeTextSandals: "Your sandal size: EU {EU}",
      measureHintSandals: "Stand on a sheet of paper wearing socks and push your heel against the wall. Mark the end of your longest toe with a vertically held pen and measure the distance to the wall. Repeat for both feet – the larger value determines your sandal size.",
      womenTab: "Women",
      menTab: "Men",
      tableHeaders: {
        eu: "EU",
        uk: "UK",
        us: "US",
        size: "Size",
        lengthMm: "Inner shoe length (mm)",
        lengthIn: "Inner shoe length (in)",
        widthMm: "Inner width (mm)",
        widthIn: "Inner width (in)"
      },
      sandalHeaders: {
        lengthMm: "Inner length (mm)",
        widthMm: "Inner width (mm)"
      }
    },
    cs: {
      sizeTitle: "Najděte velikost bot",
      unitLabel: "Jednotka",
      footLengthLabelMm: "Délka nohy (v mm)",
      footLengthLabelInch: "Délka nohy (v inch)",
      placeholderLengthMm: "např. 270",
      placeholderLengthInch: "např. 10,6",
      measureHint: "Postavte se v ponožkách na list papíru a zatlačte patu ke zdi. Označte konec nejdelšího prstu svisle drženou tužkou a změřte vzdálenost ke zdi. Opakujte pro obě nohy – větší hodnota určuje vaši velikost BLUSUN.",
      calculateButton: "Vypočítat velikost",
      chartButton: "Tabulka velikostí",
      errorText: "Zadejte všechny hodnoty.",
      noSizeText: "Nenalezena odpovídající velikost.",
      sizeText: "Velikost: EU {EU} / US {US}",
      sizeTextEuOnly: "Velikost: EU {EU}",
      placeholderText: "Zde se zobrazí vaše velikost bot",
      // Overlay translations
      overlayIntro1: "Pokud si nejste jisti svou velikostí bot, můžete zde najít správnou velikost podle našich rozměrů.",
      overlayIntro2: "Prosím vezměte na vědomí, že při měření nohy byste měli vždy přidat 10-12 mm prostoru. Naše kopyto jsou navržena tak, aby se optimálně přizpůsobila noze jak v délce, tak v šířce. Následující tabulka ukazuje vnitřní rozměry bot našich bosých bot.",
      overlayIntro2Sandals: "Prosím vezměte na vědomí, že při měření nohy byste měli vždy přidat 10-12 mm prostoru. Následující tabulka ukazuje vnitřní rozměry podrážky našich sandálů.",
      overlayIntro1Sandals: "Pokud si nejste jisti velikostí sandálů, můžete zde najít správnou velikost podle našich rozměrů.",
      placeholderTextSandals: "Zde se zobrazí vaše velikost sandálů",
      sizeTextSandals: "Velikost sandálů: EU {EU}",
      measureHintSandals: "Postavte se v ponožkách na list papíru a zatlačte patu ke zdi. Označte konec nejdelšího prstu svisle drženou tužkou a změřte vzdálenost ke zdi. Opakujte pro obě nohy – větší hodnota určuje vaši velikost sandálů.",
      womenTab: "Ženy",
      menTab: "Muži",
      tableHeaders: {
        eu: "EU",
        uk: "UK",
        us: "US",
        size: "Velikost",
        lengthMm: "Vnitřní délka boty (mm)",
        lengthIn: "Vnitřní délka boty (in)",
        widthMm: "Vnitřní šířka (mm)",
        widthIn: "Vnitřní šířka (in)"
      },
      sandalHeaders: {
        lengthMm: "Vnitřní délka (mm)",
        widthMm: "Vnitřní šířka (mm)"
      }
    },
    es: {
      sizeTitle: "Encuentra tu talla",
      unitLabel: "Unidad",
      footLengthLabelMm: "Longitud del pie (en mm)",
      footLengthLabelInch: "Longitud del pie (en inch)",
      placeholderLengthMm: "p.ej. 270",
      placeholderLengthInch: "p.ej. 10,6",
      measureHint: "Colócate sobre una hoja de papel con calcetines y apoya el talón contra la pared. Marca el extremo de tu dedo más largo con un lápiz en posición vertical y mide la distancia hasta la pared. Repite con ambos pies: el valor mayor determina tu talla BLUSUN.",
      calculateButton: "Calcular talla",
      chartButton: "Tabla de tallas",
      errorText: "Introduce todos los valores.",
      noSizeText: "No se encontró talla adecuada.",
      sizeText: "Tu talla: EU {EU} / US {US}",
      sizeTextEuOnly: "Tu talla: EU {EU}",
      placeholderText: "Aquí aparecerá tu talla de zapato",
      // Overlay translations
      overlayIntro1: "Si no estás seguro de tu talla de zapato, puedes encontrar la talla correcta aquí usando nuestras medidas.",
      overlayIntro2: "Ten en cuenta que al medir tu pie, siempre debes agregar 10-12 mm de espacio. Nuestras hormas están diseñadas para adaptarse óptimamente al pie tanto en longitud como en ancho. La siguiente tabla muestra las medidas internas de nuestros zapatos descalzos.",
      overlayIntro2Sandals: "Ten en cuenta que al medir tu pie, siempre debes agregar 10-12 mm de espacio. La siguiente tabla muestra las medidas internas de la suela de nuestras sandalias.",
      overlayIntro1Sandals: "Si no estás seguro de tu talla de sandalias, puedes encontrar la talla correcta aquí usando nuestras medidas.",
      placeholderTextSandals: "Aquí aparecerá tu talla de sandalias",
      sizeTextSandals: "Tu talla de sandalias: EU {EU}",
      measureHintSandals: "Colócate sobre una hoja de papel con calcetines y apoya el talón contra la pared. Marca el extremo de tu dedo más largo con un lápiz en posición vertical y mide la distancia hasta la pared. Repite con ambos pies: el valor mayor determina tu talla de sandalias.",
      womenTab: "Mujeres",
      menTab: "Hombres",
      tableHeaders: {
        eu: "EU",
        uk: "UK",
        us: "US",
        size: "Talla",
        lengthMm: "Longitud interna del zapato (mm)",
        lengthIn: "Longitud interna del zapato (in)",
        widthMm: "Ancho interno (mm)",
        widthIn: "Ancho interno (in)"
      },
      sandalHeaders: {
        lengthMm: "Longitud interna (mm)",
        widthMm: "Ancho interno (mm)"
      }
    }
  };

  // Aktuell gewählte Einheit (mm oder inch)
  var blusunUnit = 'mm';

  // Fallback, falls der Datenblock fehlt (z. B. gecachtes altes Snippet):
  // entspricht der bisherigen fest verdrahteten Barfußschuh-Tabelle.
  var blusunChartFallback = {
    variant: 'shoes',
    showUs: true,
    sizes: [
      { eu: 36, us: "4.5", minLength: 224, maxLength: 230 },
      { eu: 37, us: "5", minLength: 231, maxLength: 239 },
      { eu: 38, us: "6", minLength: 240, maxLength: 246 },
      { eu: 39, us: "7", minLength: 247, maxLength: 253 },
      { eu: 40, us: "7.5", minLength: 254, maxLength: 259 },
      { eu: 41, us: "8", minLength: 260, maxLength: 266 },
      { eu: 42, us: "8.5", minLength: 267, maxLength: 273 },
      { eu: 43, us: "9.5", minLength: 274, maxLength: 278 },
      { eu: 44, us: "10", minLength: 279, maxLength: 287 },
      { eu: 45, us: "11", minLength: 288, maxLength: 293 },
      { eu: 46, us: "12", minLength: 294, maxLength: 300 }
    ]
  };

  // Liest die Größendaten aus #blusunSizeChartData (von size-finder-content.liquid
  // je Variante ausgegeben). Nicht cachen – die Collection-Sidebar wird bei
  // AJAX-Filterung neu gerendert und tauscht den Datenblock mit aus.
  function getSizeChartData() {
    var node = document.getElementById('blusunSizeChartData');
    if (!node) return blusunChartFallback;
    try {
      var data = JSON.parse(node.textContent);
      if (data && data.sizes && data.sizes.length) return data;
    } catch (e) {
      if (window.console) console.warn('[size-finder] Größendaten nicht lesbar:', e);
    }
    return blusunChartFallback;
  }

  // Wechselt die Einheit, rechnet einen bereits eingegebenen Wert um und aktualisiert die Anzeige
  function setUnit(unit) {
    if (unit === blusunUnit) return;

    const input = document.getElementById("footLength");
    const val = parseFloat(input.value);
    if (!isNaN(val)) {
      if (unit === 'inch') {
        input.value = (val / 25.4).toFixed(1);
      } else {
        input.value = Math.round(val * 25.4);
      }
    }

    blusunUnit = unit;

    const mmBtn = document.getElementById("unitMm");
    const inchBtn = document.getElementById("unitInch");
    if (mmBtn) {
      mmBtn.classList.toggle('active', unit === 'mm');
      mmBtn.setAttribute('aria-pressed', unit === 'mm');
    }
    if (inchBtn) {
      inchBtn.classList.toggle('active', unit === 'inch');
      inchBtn.setAttribute('aria-pressed', unit === 'inch');
    }

    updateTranslations();
  }

  // Funktion, die die Texte anhand der aktuellen Sprache in die entsprechenden Elemente einfügt
  function updateTranslations() {
    // Fallback auf "de", wenn keine Sprache erkannt wird
    let lang = document.documentElement.lang || "de";
    
    // Prüfen, ob die erkannte Sprache unterstützt wird, sonst Fallback auf "de"
    if (!translations[lang]) {
      lang = "de";
    }
    
    const langData = translations[lang];
    
    const elements = {
      sizeTitle: document.getElementById("sizeTitle"),
      unitLabel: document.getElementById("unitLabel"),
      footLengthLabel: document.getElementById("footLengthLabel"),
      measureHint: document.getElementById("measureHint"),
      calculateButton: document.getElementById("calculateButton"),
      chartButton: document.getElementById("chartButton"),
      sizeResult: document.getElementById("sizeResult")
    };
    
    if (elements.sizeTitle) elements.sizeTitle.innerText = langData.sizeTitle;
    if (elements.unitLabel) elements.unitLabel.innerText = langData.unitLabel;
    if (elements.footLengthLabel) {
      elements.footLengthLabel.innerText = blusunUnit === 'inch' ? langData.footLengthLabelInch : langData.footLengthLabelMm;
    }
    const footLengthInput = document.getElementById("footLength");
    if (footLengthInput) {
      footLengthInput.placeholder = blusunUnit === 'inch' ? langData.placeholderLengthInch : langData.placeholderLengthMm;
    }
    const isSandals = getSizeChartData().variant === 'sandals';

    if (elements.measureHint) {
      elements.measureHint.innerText = isSandals
        ? (langData.measureHintSandals || langData.measureHint)
        : langData.measureHint;
    }
    if (elements.calculateButton) elements.calculateButton.innerText = langData.calculateButton;
    if (elements.chartButton) elements.chartButton.innerText = langData.chartButton;

    // Setze den Platzhaltertext, falls noch kein Ergebnis angezeigt wird.
    // Abgeglichen wird gegen ALLE bekannten Platzhalter (jede Sprache, beide
    // Varianten) – sonst bleibt beim Sprach- oder Variantenwechsel ein alter
    // Platzhalter stehen, während ein echtes Ergebnis erhalten bleiben muss.
    const placeholderKey = isSandals ? 'placeholderTextSandals' : 'placeholderText';
    if (elements.sizeResult) {
      const current = elements.sizeResult.innerText.trim();
      const knownPlaceholders = [];
      Object.keys(translations).forEach(function (code) {
        knownPlaceholders.push(translations[code].placeholderText);
        if (translations[code].placeholderTextSandals) {
          knownPlaceholders.push(translations[code].placeholderTextSandals);
        }
      });
      if (!current || knownPlaceholders.indexOf(current) !== -1) {
        elements.sizeResult.innerText = langData[placeholderKey] || langData.placeholderText;
      }
    }
  }

  // Funktion zur Ermittlung der Schuhgröße basierend auf den eingegebenen Werten
  function findSize() {
    const lang = document.documentElement.lang || "de";
    const langData = translations[lang] || translations.de;
    let footLength = parseFloat(document.getElementById("footLength").value);
    const resultElement = document.getElementById("sizeResult");

    // Reset previous styling
    resultElement.classList.remove('success', 'error', 'show-result');

    if (!footLength) {
      resultElement.innerText = langData.errorText;
      resultElement.classList.add('error', 'show-result');
      return;
    }

    // Eingabe in Inch für den Tabellenabgleich nach mm umrechnen
    if (blusunUnit === 'inch') {
      footLength = footLength * 25.4;
    }

    const chartData = getSizeChartData();
    const closestSize = chartData.sizes.find(s => footLength >= s.minLength && footLength <= s.maxLength);

    if (!closestSize) {
      resultElement.innerText = langData.noSizeText;
      resultElement.classList.add('error', 'show-result');
    } else {
      // Sandalen haben keine US-Entsprechung → nur EU ausgeben, und zwar
      // ausdrücklich als „Sandalengröße“, damit das Ergebnis eindeutig ist.
      if (chartData.showUs === false || !closestSize.us) {
        const euOnly = chartData.variant === 'sandals'
          ? (langData.sizeTextSandals || langData.sizeTextEuOnly || langData.sizeText)
          : (langData.sizeTextEuOnly || langData.sizeText);
        resultElement.innerText = euOnly.replace("{EU}", closestSize.eu);
      } else {
        resultElement.innerText = langData.sizeText
          .replace("{EU}", closestSize.eu)
          .replace("{US}", closestSize.us);
      }
      resultElement.classList.add('success', 'show-result');
    }
  }

  // Size Chart Overlay Functions
  function showSizeChart() {
    updateOverlayTranslations(); // Update translations before showing
    const overlay = document.getElementById('sizeChartOverlay');
    if (overlay) {
      overlay.classList.add('show');
      document.body.style.overflow = 'hidden'; // Prevent background scrolling
    }
  }
  
  // Update overlay translations
  function updateOverlayTranslations() {
    const lang = document.documentElement.lang || "de";
    const langData = translations[lang] || translations.de;
    
    // Sandalen-Overlay hat eine andere Tabelle (nur Größe/Länge/Breite) und einen
    // eigenen Einleitungstext – Variante kommt aus dem Datenblock des Snippets.
    const isSandals = getSizeChartData().variant === 'sandals';

    // Update intro texts
    const intro1 = document.querySelector('.blusun-overlay-intro1');
    const intro2 = document.querySelector('.blusun-overlay-intro2');
    if (intro1) {
      intro1.innerText = isSandals
        ? (langData.overlayIntro1Sandals || langData.overlayIntro1)
        : langData.overlayIntro1;
    }
    if (intro2) {
      intro2.innerText = isSandals
        ? (langData.overlayIntro2Sandals || langData.overlayIntro2)
        : langData.overlayIntro2;
    }

    // Update tab buttons (bei Sandalen nicht vorhanden)
    const womenTab = document.querySelector('.blusun-tab-women');
    const menTab = document.querySelector('.blusun-tab-men');
    if (womenTab) womenTab.innerText = langData.womenTab;
    if (menTab) menTab.innerText = langData.menTab;

    // Update table headers
    const headers = langData.tableHeaders;
    const sandalHeaders = langData.sandalHeaders || {};
    document.querySelectorAll('.blusun-header-eu').forEach(el => el.innerText = headers.eu);
    document.querySelectorAll('.blusun-header-uk').forEach(el => el.innerText = headers.uk);
    document.querySelectorAll('.blusun-header-us').forEach(el => el.innerText = headers.us);
    document.querySelectorAll('.blusun-header-size').forEach(el => el.innerText = headers.size);
    document.querySelectorAll('.blusun-header-length-mm').forEach(el => {
      el.innerText = isSandals ? (sandalHeaders.lengthMm || headers.lengthMm) : headers.lengthMm;
    });
    document.querySelectorAll('.blusun-header-length-in').forEach(el => el.innerText = headers.lengthIn);
    document.querySelectorAll('.blusun-header-width-mm').forEach(el => {
      el.innerText = isSandals ? (sandalHeaders.widthMm || headers.widthMm) : headers.widthMm;
    });
    document.querySelectorAll('.blusun-header-width-in').forEach(el => el.innerText = headers.widthIn);
  }

  function closeSizeChart(event) {
    // Only close if clicked on overlay background or close button
    if (!event || event.target === document.getElementById('sizeChartOverlay') || event.target.classList.contains('blusun-overlay-close')) {
      const overlay = document.getElementById('sizeChartOverlay');
      if (overlay) {
        overlay.classList.remove('show');
        document.body.style.overflow = ''; // Restore scrolling
      }
    }
  }

  // Tab switching function
  function switchTab(tabName) {
    // Hide all tab contents
    const tabContents = document.querySelectorAll('.blusun-tab-content');
    tabContents.forEach(tab => tab.classList.remove('active'));
    
    // Remove active class from all tab buttons
    const tabBtns = document.querySelectorAll('.blusun-tab-btn');
    tabBtns.forEach(btn => btn.classList.remove('active'));
    
    // Show selected tab content
    const selectedTab = document.getElementById(tabName + '-tab');
    if (selectedTab) {
      selectedTab.classList.add('active');
    }
    
    // Add active class to clicked tab button
    const clickedBtn = event.target;
    if (clickedBtn) {
      clickedBtn.classList.add('active');
    }
  }

  // Close overlay with ESC key
  document.addEventListener('keydown', function(event) {
    if (event.key === 'Escape') {
      closeSizeChart();
    }
  });

  // Update der Texte direkt nach dem Laden der Seite und sofort ausführen
  document.addEventListener("DOMContentLoaded", updateTranslations);
  
  // Sofortige Ausführung der Übersetzungsfunktion, um sicherzustellen, dass Texte angezeigt werden
  updateTranslations();
